import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import(/* webpackChunkName: "Dashboard" */ '@/views/Login'),
    },
    {
      path: '/logout',
      name: 'Logout',
      component: () => import(/* webpackChunkName: "Logout" */ '@/views/Logout'),
    },
    {
      path: '/password-change',
      name: 'PasswordChange',
      component: () => import(/* webpackChunkName: "Dashboard" */ '@/views/PasswordChange'),
    },
    {
      path: '/',
      name: 'Dashboard',
      meta: { 
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "Dashboard" */ '@/views/Dashboard'),
    },
    {
      path: '/cars',
      name: 'Cars',
      meta: { 
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "Cars" */ '@/views/cars/Cars'),
    },
    {
      path: '/cars/:id',
      name: 'CarView',
      meta: { 
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "CarView" */ '@/views/cars/CarView'),
    },

    {
      path: '/controls',
      name: 'Controls',
      meta: { 
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "Controls" */ '@/views/controls/Controls'),
    },
    {
      path: '/control/:carId',
      name: 'CarDetail',
      meta: { 
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "CarAdmission" */ '@/views/controls/CarDetail'),
    },
    {
      path: '/control/:carId/admission',
      name: 'CarAdmission',
      meta: { 
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "CarAdmission" */ '@/views/controls/CarAdmission'),
    },
    {
      path: '/control/:carId/damages',
      name: 'CarDamages',
      meta: { 
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "CarAdmission" */ '@/views/controls/CarDamages'),
    },
    {
      path: '/control/:carId/move',
      name: 'CarMove',
      meta: { 
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "CarMove" */ '@/views/controls/CarMove'),
    },
    {
      path: '/control/:carId/dispatch',
      name: 'CarDispatch',
      meta: { 
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "CarDispatch" */ '@/views/controls/CarDispatch'),
    },
    {
      path: '/control/:carId/pre-delivery',
      name: 'CarPreDelivery',
      meta: { 
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "CarAdmission" */ '@/views/controls/CarPreDelivery'),
    },
    {
      path: '/control/:carId/delivery',
      name: 'CarDelivery',
      meta: { 
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "CarAdmission" */ '@/views/controls/CarDelivery'),
    },
    {
      path: '/control/:carId/charges',
      name: 'CarCharges',
      meta: { 
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "CarCharges" */ '@/views/controls/CarCharges'),
    },
    {
      path: '/control/:carId/transfer-:action',
      name: 'CarTransfer',
      meta: { 
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "CarTransfer" */ '@/views/controls/CarTransfer'),
    },
    {
      path: '/control/:carId/fuel-load',
      name: 'CarFuelLoad',
      meta: { 
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "CarTransfer" */ '@/views/controls/CarFuelLoad'),
    },


    {
      path: '/transfers/start',
      name: 'TransferStart',
      meta: { 
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "CarView" */ '@/views/transfers/TransferStart'),
    },
    {
      path: '/transfers/end',
      name: 'TransferEnd',
      meta: { 
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "CarView" */ '@/views/transfers/TransferEnd'),
    },
    
    {
      path: '*',
      redirect: '/'
    }
  ]
})

router.beforeEach((to, from, next) => {
  var loggedIn = localStorage.getItem('logged-pos');
  loggedIn = JSON.parse(loggedIn)
  // console.log('router.beforeEach loggedIn', loggedIn);
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (loggedIn ) {
      console.log('router  estoy logueado')
      next()
      return
    }
    console.log('router  go to login')
    next('/login') 
    // next()
  } else {
    next()
  }
})

export default router